import { Box, Typography } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useNavigate } from "react-router-dom";
import { useAdminStyles } from "./adminStyles";

export const AdminPageHeader = ({
  eyebrow,
  title,
  subtitle,
  back,
  backTo,
  actions,
}) => {
  const classes = useAdminStyles();
  const navigate = useNavigate();

  const handleBack = () => {
    if (typeof back === "function") {
      back();
    } else if (backTo) {
      navigate(backTo);
    } else {
      navigate(-1);
    }
  };

  return (
    <Box className={classes.pageHeader}>
      <Box className={classes.pageHeaderLeft}>
        {(back || backTo) && (
          <button
            type="button"
            className={classes.pageBackBtn}
            onClick={handleBack}
            aria-label="Back"
          >
            <ArrowBackIcon />
          </button>
        )}
        <Box className={classes.pageTitleBlock}>
          {eyebrow && (
            <Typography className={classes.pageEyebrow}>{eyebrow}</Typography>
          )}
          <Typography component="h1" className={classes.pageTitle}>
            {title}
          </Typography>
          {subtitle && (
            <Typography className={classes.pageSubtitle}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
      {actions && <Box style={{ display: "flex", gap: 10 }}>{actions}</Box>}
    </Box>
  );
};
